export default __webpack_public_path__ + "images/favicon-32.png";